module.exports = __webpack_public_path__ + "img/pic-0.92641762.png";